/*
 * IMPORTS
 */
import React from "react"; // Npm: react.js library.
import { Flex, Text } from "@chakra-ui/react"; // Npm: Chakra UI components.

/*
 * PACKAGES
 */
import Clock from "components/Clock";
import VendorAccountConnected from "components/VendorAccountConnected";
import PlatformMargin from "components/PlatformMargin";
import CustomerAccountConnected from "components/CustomerAccountConnected";
import ErrorCode from "components/ErrorCode";
import Map from "components/MapCard";
import CustomerStatsGraph from "components/CustomerStatsGraph";

/*
 * EXPORTS
 */
const Index = () => {
  // Return component.
  return (
    <Flex
      marginTop={{ base: "680px", md: "390px", lg: "420px", xl: "240px" }}
      direction={{ base: "column" }}
      fontFamily="DM Sans"
    >
      <Flex
        flexDir={{ base: "column", lg: "row" }}
        gap={{ base: "12px", md: "22px" }}
        mb={{ base: "12px", md: "22px" }}
        width="100%"
      >
        <Flex flex={{ base: 0.6, lg: 0.5, xl: 0.6 }} minWidth={0}>
          <Clock />
        </Flex>
        <Flex
          flexDir="column"
          flex={{ base: 0.4, lg: 0.5, xl: 0.4 }}
          gap="22px"
          overflowX={{ base: "hidden", md: "auto" }}
          minWidth={0}
          w="100%"
          maxW="100%"
        >
          <PlatformMargin />
          <Map />
        </Flex>
      </Flex>
      <Flex flexDir="column">
        <Text
          textColor="#2B3674"
          fontWeight="bold"
          fontFamily="Poppins"
          fontSize={["clamp(20px, 3vw, 40px)"]}
          lineHeight="40px"
          letterSpacing="0.48px"
          py="20px"
          pl="20px"
        >
          Monitoring
        </Text>
        <Flex
          mt={{ base: "12px", md: "22px" }}
          flexDir={{ base: "column", lg: "row" }}
          gap={{ base: "12px", md: "22px" }}
          width="100%"
        >
          <Flex flex={0.5} minWidth={0}>
            <VendorAccountConnected
              title="CONNECTED VENDOR ACCOUNTS"
              isConnect={true}
            />
          </Flex>
          <Flex flex={0.5} minWidth={0}>
            <VendorAccountConnected
              title="NOT CONNECTED VENDOR ACCOUNTS"
              isConnect={false}
            />
          </Flex>
        </Flex>
      </Flex>
      <Flex
        mt={{ base: "12px", md: "22px" }}
        flexDir={{ base: "column", lg: "row" }}
        gap={{ base: "12px", md: "22px" }}
        width="100%"
      >
        <Flex flex={0.5} minWidth={0}>
          <CustomerAccountConnected
            title="CONNECTED CUSTOMER ACCOUNTS"
            isConnect={true}
          />
        </Flex>
        <Flex flex={0.5} minWidth={0}>
          <CustomerAccountConnected
            title="NOT CONNECTED CUSTOMER ACCOUNTS"
            isConnect={false}
          />
        </Flex>
      </Flex>

      <Flex
        mt={{ base: "12px", md: "22px" }}
        flexDir={{ base: "column", lg: "row" }}
        gap={{ base: "12px", md: "22px" }}
        alignItems="stretch"
      >
        <Flex flex={0.5} minWidth={0} display="flex" w="100%">
          <ErrorCode title="ERROR CODE" isConnect={false} />
        </Flex>
        <Flex flex={0.5} minWidth={0} display="flex" w="100%">
          <CustomerStatsGraph title="CUSTOMER STATS" isConnect={false} />
        </Flex>
      </Flex>
    </Flex>
  );
};

/*
 * EXPORTS
 */
export default Index;
